import React from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { Printer, ArrowLeft } from 'lucide-react';
import { DEMO_TAGS, encodeTag, taskType } from './frontlineDemo';
import './frontline.css';

// Print-friendly sheet of demo asset tags to stick around the room and scan with the worker's phone.
export default function DemoTagsPage() {
  return (
    <main className="fl-tags-page" data-testid="fl-tags-page">
      <header className="fl-tags-head fl-noprint">
        <Link to="/mirror/frontline/worker/work" className="pie-btn pie-btn-ghost" data-testid="fl-tags-back"><ArrowLeft size={14} /> Back to Frontline demo</Link>
        <div>
          <h1 style={{ margin: 0 }}>Demo asset tags</h1>
          <p className="fl-muted" style={{ margin: '4px 0 0', fontSize: 13 }}>Print this page, cut along the lines and stick a tag on each "asset". In Mirror → My work → Add a job → Scan QR code, point the phone at a tag. <span className="fl-demo-tag">Demo data</span></p>
        </div>
        <button type="button" className="pie-btn pie-btn-primary" onClick={() => window.print()} data-testid="fl-tags-print"><Printer size={14} /> Print</button>
      </header>
      <section className="fl-tags-grid">
        {DEMO_TAGS.map((t) => (
          <article key={t.wo} className="fl-tag" data-testid={`fl-tag-${t.wo}`}>
            <QRCodeSVG value={encodeTag(t)} size={168} level="M" marginSize={1} />
            <strong>{t.wo}</strong>
            <span>{t.asset}</span>
            <small>{taskType(t.type).label} · {t.complexity} complexity</small>
            <small className="fl-tag-code">{encodeTag(t)}</small>
          </article>
        ))}
      </section>
    </main>
  );
}
